module.exports = __webpack_public_path__ + "static/img/city-map-bg.d00e8ab7.png";